module.exports = __webpack_public_path__ + "models/scene3kids.b42aff4.txt";